@if (isBrowser) {
    <div
        class="snackbar-stack snackbar-stack--bottom"
        aria-live="polite"
        aria-atomic="false"
    >
        @for (item of bottomItems(); track item.msg.id) {
            <div
                class="snackbar snackbar--bottom"
                [class.snackbar--leaving]="item.leaving"
                role="status"
            >
                <span class="snackbar__msg">{{ item.msg.message }}</span>
                @if (item.msg.action) {
                    <button
                        type="button"
                        class="snackbar__action"
                        (click)="onDismiss(item.msg.id)"
                    >
                        {{ item.msg.action }}
                    </button>
                }
            </div>
        }
    </div>

    <div
        class="snackbar-stack snackbar-stack--top-right"
        aria-live="polite"
        aria-atomic="false"
    >
        @for (item of topRightItems(); track item.msg.id) {
            <div
                class="snackbar snackbar--top-right"
                [class.snackbar--leaving]="item.leaving"
                role="status"
            >
                <span class="snackbar__msg">{{ item.msg.message }}</span>
                @if (item.msg.action) {
                    <button
                        type="button"
                        class="snackbar__action"
                        (click)="onDismiss(item.msg.id)"
                    >
                        {{ item.msg.action }}
                    </button>
                }
            </div>
        }
    </div>
}
